import queryString from 'query-string';
import React from 'react';
import { Route } from 'react-router-dom';
import { ModalContainer } from '../modal/common/ModalContainer';
import { BragiResizingContainer } from '../shared/BragiResizingContainer';
import { saveLTMobileAppPromoUserResponse } from '../../utils/ltMobileAppPromo';

/**
 * A route that Wraps route componenets with a resizing container for responsiveness. Also
 * connects to several streams for use within the various views.
 */
export const BragiRoute = ({
  component: Component,
  resize,
  auth = { isLoading: true },
  onEnter = null,
  connectedProps,
  ...rest
}: {
  component: React.ComponentType<any>
  resize: boolean
  auth: { isLoading: boolean }
  onEnter?: null | ((props: any) => void)
  connectedProps: any
}) => (
  <Route {...rest}
    render={(routeProps) => {
      if (routeProps.match.params &&
        routeProps.match.params.masterId &&
        routeProps.match.params.masterId.indexOf('-') > -1) {
        const parts = routeProps.match.params.masterId.split('-');
        routeProps.match.params.masterId = parts.pop();
        routeProps.match.params.vanityToken = parts.join('-');
      }
      const query = queryString.parse(window.location.search);
      const pairs = {
        ...routeProps.match.params,
        ...query,
        ...connectedProps,
        ...rest,
      };
      try {
        if (typeof pairs.filters === 'string') {
          pairs.filters = pairs.filters ? JSON.parse(pairs.filters) : null;
        }
        else {
          pairs.filters = null;
        }
      }
      catch (e) {
        pairs.filters = null;
      }
      if (onEnter) {
        onEnter(pairs);
      }
      // LT Digital navigates directly to athlinks pages and includes this param
      // we need this to suppress the promo modal within the LT Digital webview
      // until they switch to using the /lifetime/redirect entrypoint for all routes
      if (query.adobe_mc) {
        saveLTMobileAppPromoUserResponse('notNow')
      }
      if (resize) {
        return (
          <BragiResizingContainer>
            <Component {...routeProps} pairs={pairs} />
            <ModalContainer />
          </BragiResizingContainer>
        );
      }
      else {
        return <Component {...routeProps} pairs={pairs} />;
      }
    }}
  />
);
